// @ts-nocheck

import React, { useContext, useState, useEffect } from "react";

import { OrderType } from "context/AdminOrdersContext";
// import AdminOrdersContext from "context/AdminOrdersContext.tsx";
import AdminOrdersContext from "../context/AdminOrdersContext";
// import UserContext from "context/UserContext";
import UserContext from "../context/UserContext";
// import useIntereval from "hooks/useInterval.ts";
import { ImCancelCircle } from "react-icons/im";
import { connection } from "utils/apiConnection.ts";
// import WithAuthentication from "Authentication/AuthenticationContext.ts";
import AuthenticationContext from "../../../context/Authentication/AuthenticationContext";

import { useParams } from "react-router-dom";
// import addCommas from "add-commas";
import { addCommas } from "@persian-tools/persian-tools";
import useWindowSize from "../../../hooks/useWindowSize";
// import useWindowSize from "utils/useWindowSize";
// datepicker
import persian from "react-date-object/calendars/persian";
import { DateObject } from "react-multi-date-picker";
const UncompletedOrderCard: React.FC<{ order: OrderType }> = ({
  order,
  index,
  pageName,
}) => {
  let { width } = useWindowSize();
  const data = [
    {
      title: "ارسال شد",
      icon: (
        <svg
          className="the-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 30 30"
        >
          <path
            id="Icon_awesome-check-circle"
            data-name="Icon awesome-check-circle"
            d="M30.563,15.563a15,15,0,1,1-15-15A15,15,0,0,1,30.563,15.563ZM13.827,23.5,24.956,12.376a.968.968,0,0,0,0-1.369L23.588,9.639a.968.968,0,0,0-1.369,0l-9.076,9.076L8.906,14.477a.968.968,0,0,0-1.369,0L6.169,15.846a.968.968,0,0,0,0,1.369l6.29,6.29a.968.968,0,0,0,1.369,0Z"
            transform="translate(-0.563 -0.563)"
            fill="#1a3764"
          />
        </svg>
      ),
      time: { label: "00:00", value: 0 },
      button: "",
      status: 3,
    },
    {
      title: "در حال آماده سازی",
      icon: (
        <svg
          className="the-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 30 30"
        >
          <circle
            id="Ellipse_297"
            data-name="Ellipse 297"
            cx="15"
            cy="15"
            r="15"
            fill="#1a3764"
          />
          <path
            id="Icon_ionic-md-create"
            data-name="Icon ionic-md-create"
            d="M4.5,16.375V19.5H7.625l9.208-9.208L13.708,7.167Zm14.75-8.5a.806.806,0,0,0,0-1.167L17.292,4.75a.806.806,0,0,0-1.167,0L14.583,6.292l3.125,3.125Z"
            transform="translate(3.5 2.5)"
            fill="#fff"
          />
        </svg>
      ),
      time: { label: "10:00", value: 600 },
      button: "آماده شد",
      status: 2,
    },
    {
      title: "در حال پردازش",
      icon: (
        <svg
          className="the-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 30 30"
        >
          <circle
            id="Ellipse_297"
            data-name="Ellipse 297"
            cx="15"
            cy="15"
            r="15"
            fill="#1a3764"
          />
          <path
            id="Icon_ionic-md-create"
            data-name="Icon ionic-md-create"
            d="M4.5,16.375V19.5H7.625l9.208-9.208L13.708,7.167Zm14.75-8.5a.806.806,0,0,0,0-1.167L17.292,4.75a.806.806,0,0,0-1.167,0L14.583,6.292l3.125,3.125Z"
            transform="translate(3.5 2.5)"
            fill="#fff"
          />
        </svg>
      ),
      time: { label: "10:00", value: 600 },
      button: "پردازش شد",
      status: 1,
    },
    {
      title: "در انتظار تایید",
      icon: (
        <svg
          className="the-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 30 30"
        >
          <circle
            id="Ellipse_264"
            data-name="Ellipse 264"
            cx="15"
            cy="15"
            r="15"
            fill="#1a3764"
          />
          <path
            id="Icon_open-reload"
            data-name="Icon open-reload"
            d="M7.509,0a7.5,7.5,0,1,0,5.332,12.825l-1.352-1.35a5.633,5.633,0,1,1-4-9.6,5.465,5.465,0,0,1,3.924,1.706L9.368,5.625H15V0L12.766,2.231A7.472,7.472,0,0,0,7.491,0Z"
            transform="translate(8 7.5)"
            fill="#fff"
            stroke="#fff"
            stroke-width="1"
          />
        </svg>
      ),
      time: { label: "02:00", value: 120 },
      button: "تایید",
      status: 0,
    },
  ];
  const { selectOrder } = useContext(AdminOrdersContext);
  const { superAdminOrders, customerOrders } = useContext(UserContext);
  const timestampToDate = (time) => {
    const a = time * 1000;
    const date = new DateObject({ date: a, calendar: persian });
    const b = new Date(a);
    return date.format();
  };
  const situation = (status) => {
    // let x;
    // if (
    //   pageName == "customer" &&
    //   (status == "-1" || status == "0" || status == "1" || status == "2")
    // ) {
    //   x = 2;
    // } else {
    //   x = status;
    // }
    console.log("123", status);
    let temp = data.filter((s) => s.status == status);
    return (
      <>
        {temp[0].icon}
        {temp[0].title}
      </>
    );
  };
  console.log("000", pageName);
  // let auth = useContext(WithAuthentication);
  // console.log(auth);
  // let parameter;
  // let param = useParams();
  console.log("pageName", pageName);
  return (
    <div className="order-card">
      <div className="order-card-body">
        <div
          className={`order-card-header  ${index % 2 == 0 ? "even" : "odd"}`}
          onClick={() => {
            selectOrder(order, true);
          }}
        >
          <div
            className={`text-center col-lg-1 col-sm-2 col-6 ${
              width < 1200 && "borderBottom"
            }`}
          >
            <div className="title">شماره</div>
            <div className="pb-2"> {order.id}</div>
          </div>
          <div
            className={`text-center col-xxl-1 col-md-2 col-sm-3 col-6 ${
              width < 1200 && "borderBottom"
            }`}
          >
            <div className="title">تاریخ</div>
            <div className=" pb-2">{timestampToDate(order.mtm)}</div>
          </div>
          <div
            className={`text-center col-xxl-1 col-lg-2 col-sm-3 col-6 ${
              width < 1200 && "borderBottom"
            }`}
          >
            <div className="title">فروشگاه</div>
            <div className=" pb-2">{}</div>
          </div>
          {!customerOrders && (
            <div
              className={`text-center col-xxl-2 col-xl-2 col-md-3 col-sm-4 col-6 ${
                width < 1200 && "borderBottom"
              }`}
            >
              <div className="title">نام و نام خانوادگی</div>
              <div className=" pb-2">
                {order.user_info.fullname == ""
                  ? "--"
                  : order.user_info.fullname}
              </div>
            </div>
          )}
          <div
            className={`text-center col-xl-1 col-md-2 col-sm-3 col-6 ${
              width < 1200 && "borderBottom"
            } ${customerOrders && width < 768 && "borderBottom"} ${
              !customerOrders && width < 768 && width > 576 && "border-0"
            } ${!customerOrders && width < 576 && "borderBottom"} `}
          >
            <div className="title">تعداد کالا</div>
            <div className=" pb-2">{order.items.length}</div>
          </div>
          <div
            className={`text-center col-lg-2 col-md-4 col-sm-3 col-6 ${
              width < 1200 && width > 992 && "borderBottom"
            } ${!customerOrders && width < 576 && "borderBottom"}`}
          >
            <div className="title">مبلغ</div>
            <div className="pb-2">
              {" "}
              {addCommas(order.total_price - order.total_discount)}
            </div>
          </div>
          <div
            className={`text-center col-xl-2 col-lg-6 col-md-4 col-sm-4 col-6 
           
            `}
          >
            <div className="title">وضعیت سفارش</div>
            <div className="pb-2">
              {/* <StatusCard status={order.lats_order_status} order={order} /> */}
              {situation(order.lats_order_status)}
            </div>
          </div>
          {superAdminOrders ? (
            <div
              // className="d-flex align-items-center"
              className={`text-center col-xxl-2 col-xl-12 col-lg-6 col-md-4 col-sm-2 col-6 pb-2 ${
                width < 1400 && width > 1200 && "borderTop"
              }`}
              style={{ cursor: "pointer" }}
            >
              <div className="title">عملیات</div>
              <div>
                <ImCancelCircle />
              </div>
              {/* <div style={{ marginRight: "4px" }}>لغو سفارش</div> */}
            </div>
          ) : (
            ""
          )}
        </div>
        {/* <div className="d-flex flex-column w-100 p-3 text-center">
          <div
            className={`orders-footer d-flex align-items-center ${
              superAdminOrders ? "justify-content-between" : "align-self-center"
            } `}
          >
            {superAdminOrders ? <div className="col-lg-1 temp"></div> : ""}

            <button
              type="button"
              className="btn"
              onClick={() => selectOrder(order)}
              style={{ display: "block" }}
            >
              جزئیات بیشتر
            </button>
          </div>
        </div> */}
      </div>
    </div>
  );
};

function StatusCard({ status, order }) {
  const [time, setTime] = useState<{ label: string; value: number }>({
    label: "00:00",
    value: 0,
  });
  const { customerOrders, superAdminOrders } = useContext(UserContext);
  const auth = useContext(AuthenticationContext);
  const data = [
    {
      title: "ارسال شد",
      icon: (
        <svg
          className="the-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
        >
          <path
            id="Icon_awesome-check-circle"
            data-name="Icon awesome-check-circle"
            d="M30.563,15.563a15,15,0,1,1-15-15A15,15,0,0,1,30.563,15.563ZM13.827,23.5,24.956,12.376a.968.968,0,0,0,0-1.369L23.588,9.639a.968.968,0,0,0-1.369,0l-9.076,9.076L8.906,14.477a.968.968,0,0,0-1.369,0L6.169,15.846a.968.968,0,0,0,0,1.369l6.29,6.29a.968.968,0,0,0,1.369,0Z"
            transform="translate(-0.563 -0.563)"
            fill="#1a3764"
          />
        </svg>
      ),
      time: { label: "00:00", value: 0 },
      button: "",
      status: 3,
    },
    {
      title: "در حال آماده سازی",
      icon: (
        <svg
          className="the-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
        >
          <circle
            id="Ellipse_297"
            data-name="Ellipse 297"
            cx="15"
            cy="15"
            r="15"
            fill="#1a3764"
          />
          <path
            id="Icon_ionic-md-create"
            data-name="Icon ionic-md-create"
            d="M4.5,16.375V19.5H7.625l9.208-9.208L13.708,7.167Zm14.75-8.5a.806.806,0,0,0,0-1.167L17.292,4.75a.806.806,0,0,0-1.167,0L14.583,6.292l3.125,3.125Z"
            transform="translate(3.5 2.5)"
            fill="#fff"
          />
        </svg>
      ),
      time: { label: "10:00", value: 600 },
      button: "آماده شد",
      status: 2,
    },
    {
      title: "در حال پردازش",
      icon: (
        <svg
          className="the-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
        >
          <circle
            id="Ellipse_297"
            data-name="Ellipse 297"
            cx="15"
            cy="15"
            r="15"
            fill="#1a3764"
          />
          <path
            id="Icon_ionic-md-create"
            data-name="Icon ionic-md-create"
            d="M4.5,16.375V19.5H7.625l9.208-9.208L13.708,7.167Zm14.75-8.5a.806.806,0,0,0,0-1.167L17.292,4.75a.806.806,0,0,0-1.167,0L14.583,6.292l3.125,3.125Z"
            transform="translate(3.5 2.5)"
            fill="#fff"
          />
        </svg>
      ),
      time: { label: "10:00", value: 600 },
      button: "پردازش شد",
      status: 1,
    },
    {
      title: "در انتظار تایید",
      icon: (
        <svg
          className="the-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
        >
          <circle
            id="Ellipse_264"
            data-name="Ellipse 264"
            cx="15"
            cy="15"
            r="15"
            fill="#1a3764"
          />
          <path
            id="Icon_open-reload"
            data-name="Icon open-reload"
            d="M7.509,0a7.5,7.5,0,1,0,5.332,12.825l-1.352-1.35a5.633,5.633,0,1,1-4-9.6,5.465,5.465,0,0,1,3.924,1.706L9.368,5.625H15V0L12.766,2.231A7.472,7.472,0,0,0,7.491,0Z"
            transform="translate(8 7.5)"
            fill="#fff"
            stroke="#fff"
            stroke-width="1"
          />
        </svg>
      ),
      time: { label: "02:00", value: 120 },
      button: "تایید",
      status: 0,
    },
  ];
  // console.log("auth", auth);

  // useInterval
  useIntereval(
    () => {
      setTime((t) => ({ label: timeMaker(t.value - 1), value: t.value - 1 }));
    },
    time !== 0 ? 1000 : null
  );

  useEffect(() => {
    setTime(data.find((v) => v.status === +status)?.time);
  }, [status]);

  function timeMaker(time) {
    if (isNaN(time)) return "";
    let hour, min, sec;
    time = +time;
    hour = Math.floor(time / 3600);
    time = Math.floor(time % 3600);
    min = Math.floor(time / 60);
    sec = Math.floor(time % 60);
    return `${hour > 10 ? hour : hour > 0 ? "0" + hour.toString() : ""}${
      hour > 0 ? ":" : ""
    }${min < 10 ? "0" : ""}${min}:${sec < 10 ? 0 : ""}${sec}`;
  }

  if (+status > 3 || +status < 0) {
    return <></>;
  }

  // async function apiHandler(status, orderId) {
  //   let result = await connection("supplier/change_order_status", {
  //     usertoken: auth.userInfo.token,
  //     status: status,
  //     order_id: orderId,
  //   }).then((res) => console.log(res));
  // }
  return (
    <div className="d-flex flex-column justify-content-center">
      {data.map((value, index) => (
        <div
          className={`row flex-column flex-md-row align-items-baseline justify-content-between status-item${
            +status === value.status
              ? " active"
              : +status > value.status
              ? " done"
              : " undone"
          }`}
          key={`status-${index}`}
        >
          <div className="col col-md-5 mt-2 status-title">
            {value.icon}
            {value.title}
          </div>
          <div
            className="col col-md-2 mt-2 time-counter"
            style={{ color: "#F0162E" }}
          >
            {value.status !== 3 && (
              <>
                {+status === value.status
                  ? time.label
                  : +status > value.status
                  ? "00:00"
                  : value.time.label}
                <svg
                  style={{ marginRight: "1rem" }}
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                >
                  <g
                    id="Icon_feather-clock"
                    data-name="Icon feather-clock"
                    transform="translate(-2 -2)"
                  >
                    <path
                      id="Path_303"
                      data-name="Path 303"
                      d="M23,13A10,10,0,1,1,13,3,10,10,0,0,1,23,13Z"
                      fill="none"
                      stroke="#f0162e"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    />
                    <path
                      id="Path_304"
                      data-name="Path 304"
                      d="M18,9v9l6,3"
                      transform="translate(-6.25 -3.333)"
                      fill="none"
                      stroke="#f0162e"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    />
                  </g>
                </svg>
              </>
            )}
          </div>
          <div className="col col-md-5 order-buttons">
            {!customerOrders && !superAdminOrders ? (
              <button
                className={`btn btn-outline-primary${
                  value.status === 0
                    ? " certify-btn"
                    : value.status === 1
                    ? " ready-btn"
                    : value.status === 2
                    ? " process-btn"
                    : " invisible"
                }`}
              >
                {value.button}
              </button>
            ) : (
              ""
            )}
            {superAdminOrders ? (
              ""
            ) : value.status === 3 && customerOrders ? (
              <button
                type="button"
                className="btn btn-outline-primary problem-btn"
                onClick={(e) => console.log(order)}
              >
                عدم دریافت
              </button>
            ) : value.status === 3 && !customerOrders ? (
              <button
                type="button"
                className="btn btn-outline-primary problem-btn"
              >
                مشکل در ارسال
              </button>
            ) : customerOrders && value.status !== 3 ? (
              ""
            ) : (
              <button
                type="button"
                className="btn btn-outline-primary problem-btn"
              >
                اعلام مشکل
              </button>
            )}
            {/* {!customerOrders ? (
              <button
                type="button"
                className="btn btn-outline-primary problem-btn"
              >
                اعلام مشکل
              </button>
            ) : customerOrders && value.status === 3 ? (
              <button
                type="button"
                className="btn btn-outline-primary problem-btn"
              >
                عدم تحویل
              </button>
            ) : (
              ""
            )} */}
          </div>
        </div>
      ))}
    </div>
  );
}

export default UncompletedOrderCard;
